module.exports = __webpack_public_path__ + "img/HTCC-HDC1080.8a6a9870.jpg";